define('collections/cd_personals',['require','collections/base','models/cd_personal'],function(require){

    var BaseCollection = require('collections/base');
    var Model = require("models/cd_personal");

    return BaseCollection.extend({
        model: Model,
        url: 'cd-managers.json'
    });
});

